module.exports = __webpack_public_path__ + "c05a75c575840e866ac405a62bc2865f.png";